<div>
    <h5 class="modal-title font-header" id="exampleModalLabel"><span> View Dynamic
            Template </span>
    </h5>
    <div class="col" style="text-align: right;">
        <button type="button" class="btn blue-btn btn-sm btngrid" (click)="SaveOrUpdateSessionPDFForm()">Update</button>
        <button type="button" class="btn blue-btn btn-sm btngrid ms-2" (click)="closeViewPdf()">Close</button>
    </div>
</div>

<div class='row mt-3'>
    <div class="col-lg-12">
        <ngx-extended-pdf-viewer [src]="pdfBase64" useBrowserLocale="true">
        </ngx-extended-pdf-viewer>


        
        <!-- <pdf-viewer [src]="pdfBase64"
        [render-text]="true"
        [original-size]="false"
        style="width: 400px; height: 500px"
></pdf-viewer> -->
    </div>
</div>